import "./App.css";
import { ThemeProvider } from "@mui/material/styles";
import DrawerLayout from "./componentes/DrawerLayout";
import RoutesMenus from "../routes";
import AppControl, { AppProvider } from "./AppContext";
import RoutesControl from "./componentes/RoutesControl";
import MenuControl from "./componentes/MenuControl";
// import { BrowserRouter } from "react-router-dom";
import { HashRouter as Router } from 'react-router-dom';
import store from "../reducer";
import { Provider } from "react-redux";
import { Suspense, useEffect, useState } from "react";
import firebaseUtil from "../firebaseUtil";
import { CircularProgress } from "@mui/material";
import { salvarPerfilLogin } from "../dbApi";
import { NotificationProvider } from "notification";
import { theme, themedark } from "AppPersonalise";
import { useCookies } from "react-cookie";
import { CookiesProvider } from "react-cookie";

function App() {
    const [firebaseInitialized, setFirebaseInitialized] = useState(false);
    const [themeUsar, setThemeUsar] = useState(theme);
    const [cookies, setCookie] = useCookies(["theme"]);
    const valueAppContext = AppControl();

    useEffect(() => {
        firebaseUtil.isInitialized(valueAppContext.setUserAux).then((val) => {
            setFirebaseInitialized(val);

            if (val) {
                salvarPerfilLogin(val);
                if (cookies.theme === 'themedark') setThemeUsar(themedark)
                else setThemeUsar(theme)
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const toggleTheme = () => {
        console.log("cookie", cookies.theme)
        if (themeUsar.palette.mode === 'dark') {
            setCookie("theme", "theme", {
                path: "/"
            });
            setThemeUsar(theme)
        } else {
            setCookie("theme", "themedark", {
                path: "/"
            });
            setThemeUsar(themedark)
        }
    }


    return firebaseInitialized !== false ? (
        <CookiesProvider>
            <Suspense fallback={<CircularProgress />}>
                <Provider store={store}>
                    <Router>
                        <ThemeProvider theme={themeUsar}>
                            <NotificationProvider>
                                <AppProvider valueUsar={valueAppContext}>
                                    <RoutesMenus />
                                    <DrawerLayout RoutesContainer={RoutesControl} MenuContainer={MenuControl} toggleTheme={toggleTheme} />
                                </AppProvider>
                            </NotificationProvider>
                        </ThemeProvider>
                    </Router>
                </Provider>
            </Suspense>
        </CookiesProvider>
    ) : (
        <div className="loader" style={{ textAlign: "center", marginTop: "1em"}}>
            <CircularProgress />
        </div>
    );
}

export default App;
